(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["play-brand-index"] && !Shopify.designMode) return;
  try {
    
  // Filtering is client-side so the whole list is present for crawlers and there
  // is no reload between letters. Progressive enhancement: with JS off nothing
  // sets `data-mode`, the stack rules never apply, and every group stays in flow
  // as a plain vertical list -- the same as ALL.
  class PlayBrandIndex extends HTMLElement {
    // How many cards either side of the front one stay in the DOM. Cards outside
    // the window are hidden outright rather than left at extreme depths: at 27
    // letters a past card would otherwise sit ~260rem toward the viewer, well
    // past the perspective plane, which both blows up its painted size and can
    // push overflow onto the page.
    static WINDOW_BEHIND = 6;
    static WINDOW_PAST = 2;

    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('.play-brand-index__letter[data-letter]'));
      this.groups = Array.from(this.querySelectorAll('.play-brand-index__group'));
      this.stack = this.querySelector('.play-brand-index__groups');
      this.empty = this.querySelector('.play-brand-index__no-results');
      this.letter = 'all';

      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      window.addEventListener('resize', this.onResize);
      this.flipNotes();
    }

    // Flip each in-store popover whose right edge would pass the screen edge.
    // Measured with the flip removed, so a row can flip back after a resize. The
    // note is only faded, never display:none, so it always has a box to measure.
    flipNotes() {
      const limit = document.documentElement.clientWidth - 8;
      this.querySelectorAll('.play-brand-index__item.is-in-store').forEach((item) => {
        const note = item.querySelector('.play-brand-index__note');
        if (!note) return;
        item.classList.remove('is-flipped');
        if (note.getBoundingClientRect().right > limit) item.classList.add('is-flipped');
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }

    onClick = (event) => {
      const button = event.target.closest('.play-brand-index__letter[data-letter]');
      if (!button) return;
      this.select(button.dataset.letter);
    };

    // Arrow keys walk the bar. Worth having beyond plain accessibility: flicking
    // through with one key held is what the card stack is for, and tabbing
    // between 27 buttons doesn't give you that.
    onKeydown = (event) => {
      const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
      if (!step) return;

      const from = this.buttons.indexOf(
        event.target.closest('.play-brand-index__letter[data-letter]')
      );
      if (from === -1) return;

      const next = this.buttons[from + step];
      if (!next) return;

      event.preventDefault();
      next.focus();
      this.select(next.dataset.letter);
    };

    onResize = () => {
      // Card height depends on its width, and out-of-flow cards can't tell the
      // container what to be, so the measurement has to be redone on resize.
      if (this.letter !== 'all') this.measure();
      this.flipNotes();
    };

    select(letter) {
      this.letter = letter;
      const flat = letter === 'all';

      this.buttons.forEach((button) => {
        const active = button.dataset.letter === letter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      this.stack.dataset.mode = flat ? 'flat' : 'stack';

      const front = this.groups.findIndex((group) => group.dataset.letter === letter);

      this.groups.forEach((group, index) => {
        if (flat) {
          group.hidden = false;
          group.inert = false;
          group.removeAttribute('data-state');
          group.style.removeProperty('--pbi-depth');
          return;
        }

        const depth = index - front;
        group.hidden =
          depth > PlayBrandIndex.WINDOW_BEHIND || depth < -PlayBrandIndex.WINDOW_PAST;
        group.style.setProperty('--pbi-depth', depth);
        group.dataset.state = depth === 0 ? 'active' : depth > 0 ? 'behind' : 'past';
        // The cards behind are a depth cue, not content: their links are visible
        // but unreadable, so they must not be tabbable or announced.
        group.inert = depth !== 0;
      });

      if (flat) {
        this.stack.style.removeProperty('--pbi-stack-h');
      } else {
        this.measure();
      }
      this.flipNotes();

      // Only reachable if a letter's group vanished from the menu after render;
      // every rendered letter button has brands behind it by construction.
      if (this.empty) this.empty.hidden = flat || front !== -1;
    }

    measure() {
      const group = this.groups.find((item) => item.dataset.state === 'active');
      if (!group) return;
      this.stack.style.setProperty('--pbi-stack-h', `${group.offsetHeight}px`);
    }
  }

  if (!customElements.get('play-brand-index')) {
    customElements.define('play-brand-index', PlayBrandIndex);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["play-community"] && !Shopify.designMode) return;
  try {
    
  // Show/hide by category. The chips and the groups are matched by block id, which
  // the section and the category block both write out, so there is no name matching
  // and nothing to keep in sync.
  class PlayCommunity extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.play-community__filter');
      this.groups = Array.from(this.querySelectorAll('[data-play-category]'));

      // One category needs no filter, and neither does none.
      if (!this.bar || this.groups.length < 2) return;

      this.buildBar();
      this.chips = Array.from(this.bar.querySelectorAll('[data-play-filter]'));

      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
    }

    // Assembled from the groups themselves, because the section cannot read its
    // nested blocks' settings -- see the note at the top of this file.
    buildBar() {
      const chip = (value, label, active) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'play-community__chip' + (active ? ' is-active' : '');
        button.dataset.playFilter = value;
        button.setAttribute('aria-pressed', active ? 'true' : 'false');

        const text = document.createElement('span');
        text.className = 'play-community__chip-text';
        // textContent, not innerHTML: these labels are client-authored.
        text.textContent = label;
        button.appendChild(text);
        return button;
      };

      const fragment = document.createDocumentFragment();
      fragment.appendChild(chip('all', this.bar.dataset.playAllLabel || 'All', true));

      this.groups.forEach((group) => {
        fragment.appendChild(
          chip(
            group.dataset.playCategory,
            group.dataset.playFilterLabel || 'Category',
            false
          )
        );
      });

      this.bar.appendChild(fragment);
      this.bar.hidden = false;
    }

    onClick = (event) => {
      const chip = event.target.closest('[data-play-filter]');
      if (!chip) return;
      this.select(chip.dataset.playFilter);
    };

    // Arrow keys walk the bar, matching the brand index.
    onKeydown = (event) => {
      const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
      if (!step) return;

      const from = this.chips.indexOf(event.target.closest('[data-play-filter]'));
      if (from === -1) return;

      const next = this.chips[from + step];
      if (!next) return;

      event.preventDefault();
      next.focus();
      this.select(next.dataset.playFilter);
    };

    select(value) {
      // Only opt into the animation once the visitor has actually filtered
      // something, so the page doesn't animate on load.
      this.classList.add('is-animated');

      this.chips.forEach((chip) => {
        const active = chip.dataset.playFilter === value;
        chip.classList.toggle('is-active', active);
        chip.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      this.groups.forEach((group) => {
        const match = value === 'all' || group.dataset.playCategory === value;
        group.hidden = !match;

        // Restart the animation on the groups that are staying, so switching
        // between two categories reads as a change rather than a jump.
        if (match) {
          group.style.animation = 'none';
          // Reading offsetHeight forces the style change to be committed, which is
          // what lets the animation restart rather than being coalesced away.
          void group.offsetHeight;
          group.style.removeProperty('animation');
        }
      });
    }
  }

  if (!customElements.get('play-community')) {
    customElements.define('play-community', PlayCommunity);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["play-logo-marquee"] && !Shopify.designMode) return;
  try {
    
  class PlayLogoMarquee extends HTMLElement {
    connectedCallback() {
      // Reduced motion keeps the still CSS row: no drift, nothing to drag.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.viewport = this.querySelector('.play-logo-marquee__viewport');
      this.track = this.querySelector('.play-logo-marquee__track');
      this.set = this.querySelector('.play-logo-marquee__set');
      if (!this.viewport || !this.track || !this.set) return;

      this.x = 0;              // px moved into the first set, kept in [0, setWidth)
      this.velocity = 0;       // px/s of drag momentum still coasting
      this.hovered = false;
      this.focused = false;
      this.drag = null;
      this.suppressClick = false;

      const duration = parseFloat(getComputedStyle(this).getPropertyValue('--plm-duration')) || 32;
      this.measure = () => {
        this.setWidth = this.set.getBoundingClientRect().width;
        this.speed = this.setWidth / duration;
      };
      this.measure();
      this.resizeObserver = new ResizeObserver(this.measure);
      this.resizeObserver.observe(this.set);

      // Hand-off from the CSS animation: from here the script sets the transform.
      this.classList.add('is-scripted');

      const vp = this.viewport;
      vp.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') this.hovered = true; });
      vp.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') this.hovered = false; });
      vp.addEventListener('pointerdown', this.onDown);
      vp.addEventListener('pointermove', this.onMove);
      vp.addEventListener('pointerup', this.onUp);
      vp.addEventListener('pointercancel', this.onUp);
      vp.addEventListener('dragstart', (e) => e.preventDefault());
      // Capture phase, so the click that ends a drag never reaches the link.
      vp.addEventListener('click', (e) => {
        if (!this.suppressClick) return;
        e.preventDefault();
        e.stopPropagation();
        this.suppressClick = false;
      }, true);
      vp.addEventListener('focusin', this.onFocus);
      vp.addEventListener('focusout', () => { this.focused = false; });

      this.last = performance.now();
      this.frame = requestAnimationFrame(this.tick);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    onDown = (e) => {
      if (e.button !== 0) return;
      this.drag = { startX: e.clientX, startOffset: this.x, lastX: e.clientX, lastT: e.timeStamp, id: e.pointerId, moved: false };
      this.velocity = 0;
    };

    onMove = (e) => {
      const d = this.drag;
      if (!d || e.pointerId !== d.id) return;
      const dx = e.clientX - d.startX;
      if (!d.moved) {
        if (Math.abs(dx) < 5) return;
        // Only now take the pointer: capturing on pointerdown would retarget a
        // plain click to the viewport and the link would never open.
        d.moved = true;
        this.viewport.setPointerCapture(e.pointerId);
        this.classList.add('is-dragging');
      }
      this.x = d.startOffset - dx;
      const dt = (e.timeStamp - d.lastT) / 1000;
      if (dt > 0) this.velocity = -(e.clientX - d.lastX) / dt;
      d.lastX = e.clientX;
      d.lastT = e.timeStamp;
      this.render();
    };

    onUp = (e) => {
      const d = this.drag;
      if (!d || e.pointerId !== d.id) return;
      if (d.moved) {
        this.suppressClick = true;
        this.classList.remove('is-dragging');
        // Cap the fling so a flick coasts rather than spins.
        this.velocity = Math.max(-3000, Math.min(3000, this.velocity));
      } else {
        this.velocity = 0;
      }
      this.drag = null;
    };

    onFocus = (e) => {
      // Keyboard focus only. Browsers also focus a link on mousedown, so a drag
      // that starts on a logo would otherwise leave the row frozen afterwards.
      // (Same rule as play-photo-strip.)
      if (!e.target.matches(':focus-visible')) return;
      this.focused = true;
      this.viewport.scrollLeft = 0;   // the browser may scroll the clipped box itself
      const link = e.target.closest('a');
      if (!link) return;
      const box = this.viewport.getBoundingClientRect();
      const r = link.getBoundingClientRect();
      if (r.left < box.left + 24) this.x -= box.left + 24 - r.left;
      else if (r.right > box.right - 24) this.x += r.right - (box.right - 24);
      this.render();
    };

    tick = (now) => {
      const dt = Math.min((now - this.last) / 1000, 0.05);
      this.last = now;
      if (!this.drag || !this.drag.moved) {
        if (Math.abs(this.velocity) > 5) {
          this.x += this.velocity * dt;
          this.velocity *= Math.pow(0.04, dt);   // momentum dies away in about a second
        } else {
          this.velocity = 0;
          if (!this.hovered && !this.focused) this.x += this.speed * dt;
        }
        this.render();
      }
      this.frame = requestAnimationFrame(this.tick);
    };

    render() {
      const w = this.setWidth;
      if (!w) return;
      // The sets are identical, so wrapping by one set width is invisible.
      this.x = ((this.x % w) + w) % w;
      this.track.style.transform = `translate3d(${-this.x}px, 0, 0)`;
    }
  }

  if (!customElements.get('play-logo-marquee')) {
    customElements.define('play-logo-marquee', PlayLogoMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["play-numbered-steps"] && !Shopify.designMode) return;
  try {
    
  // Reveals each card's number as it scrolls in. One observer for the section
  // rather than a scroll handler, and it unobserves after firing -- the number
  // should not slide away again when the card leaves the viewport.
  //
  // The numbers are already in their resting position from CSS. This only opts into
  // the animation, by adding `is-animated`, once it is certain it can finish the
  // job. Every bail-out below therefore just leaves the section as it renders
  // without JS: numbers visible, no slide.
  class PlayNumberedSteps extends HTMLElement {
    connectedCallback() {
      const cards = Array.from(this.querySelectorAll('.play-steps__card'));
      if (!cards.length) return;

      // Nothing to defer if the visitor asked for less motion, and nothing to
      // drive the reveal with if the browser has no observer.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;

      this.classList.add('is-animated');

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            this.observer.unobserve(entry.target);
          });
        },
        {
          // Threshold alone fired while the card was still down at the bottom of
          // the screen, so the slide had finished before it was worth looking at.
          // The negative bottom margin shrinks the observed area up from the foot
          // of the viewport, which means the card has to climb to roughly mid
          // screen before it counts as visible -- that is where the reveal reads.
          rootMargin: '0px 0px -30% 0px',
          threshold: 0.35,
        }
      );

      cards.forEach((card) => this.observer.observe(card));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('play-numbered-steps')) {
    customElements.define('play-numbered-steps', PlayNumberedSteps);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["play-photo-strip"] && !Shopify.designMode) return;
  try {
    
  class PlayPhotoStrip extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.play-photo-strip__viewport');
      this.track = this.querySelector('.play-photo-strip__track');
      this.set = this.querySelector('.play-photo-strip__set');
      this.dialog = this.querySelector('.play-photo-strip__lightbox');
      if (!this.viewport || !this.track || !this.set) return;

      this.photos = [...this.set.querySelectorAll('[data-strip-photo]')];
      this.suppressClick = false;
      this.setupLightbox();

      // Reduced motion keeps the still, scrollable CSS row: no drift, no drag.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.x = 0;              // px moved into the first set, kept in [0, setWidth)
      this.velocity = 0;       // px/s of drag momentum still coasting
      this.hovered = false;
      this.focused = false;
      this.drag = null;

      const duration = parseFloat(getComputedStyle(this).getPropertyValue('--pps-duration')) || 48;
      this.measure = () => {
        this.setWidth = this.set.getBoundingClientRect().width;
        this.speed = this.setWidth / duration;
      };
      this.measure();
      // Lazy photos have their box before they load (aspect-ratio), but a
      // resize or a font swap in the heading can still change the width.
      this.resizeObserver = new ResizeObserver(this.measure);
      this.resizeObserver.observe(this.set);

      this.classList.add('is-scripted');

      const vp = this.viewport;
      vp.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') this.hovered = true; });
      vp.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') this.hovered = false; });
      vp.addEventListener('pointerdown', this.onDown);
      vp.addEventListener('pointermove', this.onMove);
      vp.addEventListener('pointerup', this.onUp);
      vp.addEventListener('pointercancel', this.onUp);
      vp.addEventListener('dragstart', (e) => e.preventDefault());
      vp.addEventListener('focusin', this.onFocus);
      vp.addEventListener('focusout', () => { this.focused = false; });

      this.last = performance.now();
      this.frame = requestAnimationFrame(this.tick);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    /* ---- Lightbox ---- */

    setupLightbox() {
      const dlg = this.dialog;
      if (!dlg) return;
      this.full = dlg.querySelector('.play-photo-strip__full');
      this.counter = dlg.querySelector('.play-photo-strip__count');

      // Capture phase, so the click that ends a drag never opens the lightbox.
      this.viewport.addEventListener('click', (e) => {
        if (this.suppressClick) {
          e.preventDefault();
          e.stopPropagation();
          this.suppressClick = false;
          return;
        }
        const btn = e.target.closest('.play-photo-strip__button');
        if (!btn) return;
        this.opener = btn;
        this.open(Number(btn.dataset.index) || 0);
      }, true);

      dlg.addEventListener('click', (e) => {
        const step = e.target.closest('[data-lightbox-step]');
        if (step) return this.show(this.index + Number(step.dataset.lightboxStep));
        // Anything that isn't the photo or a control closes: the dark backdrop,
        // the space around the photo, the close button.
        if (e.target.closest('[data-lightbox-close]') || !e.target.closest('.play-photo-strip__full, .play-photo-strip__nav')) {
          dlg.close();
        }
      });

      dlg.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.show(this.index - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); this.show(this.index + 1); }
      });

      dlg.addEventListener('close', () => {
        document.documentElement.style.removeProperty('overflow');
        // Focus goes back to the photo that opened it (the browser may already
        // have done this before this event fires). That must not pause the
        // strip: onFocus ignores focus arriving while lightboxOpen is set.
        if (this.opener) this.opener.focus({ preventScroll: true });
        this.lightboxOpen = false;
        // Closed from the keyboard: keep the strip still, so the focused photo
        // doesn't drift away with its focus ring. After a mouse close it moves on.
        this.focused = !!this.opener && this.opener.matches(':focus-visible');
      });

      // Sideways swipe on the photo steps through the set.
      let sx = null, sy = null;
      const fig = dlg.querySelector('.play-photo-strip__figure');
      fig.addEventListener('pointerdown', (e) => { sx = e.clientX; sy = e.clientY; });
      fig.addEventListener('pointerup', (e) => {
        if (sx === null) return;
        const dx = e.clientX - sx, dy = e.clientY - sy;
        sx = sy = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.swiped = true;
          this.show(this.index + (dx < 0 ? 1 : -1));
        }
      });
      // A swipe ends in a click; don't let it close the lightbox.
      fig.addEventListener('click', (e) => {
        if (!this.swiped) return;
        this.swiped = false;
        e.stopPropagation();
      }, true);
    }

    open(i) {
      this.lightboxOpen = true;
      this.show(i);
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
    }

    show(i) {
      const n = this.photos.length;
      if (!n) return;
      this.index = ((i % n) + n) % n;
      const p = this.photos[this.index];
      const img = this.full;
      img.removeAttribute('src');
      img.srcset = p.dataset.fullSrcset;
      img.sizes = '(max-width: 749px) 100vw, 90vw';
      img.width = Number(p.dataset.width);
      img.height = Number(p.dataset.height);
      img.alt = p.dataset.alt || '';
      img.src = p.dataset.fullSrc;
      if (this.counter) this.counter.textContent = n > 1 ? `${this.index + 1} / ${n}` : '';
      // Keep the next photo ready so stepping through feels instant.
      const next = this.photos[(this.index + 1) % n];
      if (next && next !== p) {
        const pre = new Image();
        pre.sizes = img.sizes;
        pre.srcset = next.dataset.fullSrcset;
      }
    }

    /* ---- Drift and drag (same as play-logo-marquee) ---- */

    onDown = (e) => {
      if (e.button !== 0) return;
      this.drag = { startX: e.clientX, startOffset: this.x, lastX: e.clientX, lastT: e.timeStamp, id: e.pointerId, moved: false };
      this.velocity = 0;
    };

    onMove = (e) => {
      const d = this.drag;
      if (!d || e.pointerId !== d.id) return;
      const dx = e.clientX - d.startX;
      if (!d.moved) {
        if (Math.abs(dx) < 5) return;
        // Only now take the pointer: capturing on pointerdown would retarget a
        // plain click to the viewport and the photo would never open.
        d.moved = true;
        this.viewport.setPointerCapture(e.pointerId);
        this.classList.add('is-dragging');
      }
      this.x = d.startOffset - dx;
      const dt = (e.timeStamp - d.lastT) / 1000;
      if (dt > 0) this.velocity = -(e.clientX - d.lastX) / dt;
      d.lastX = e.clientX;
      d.lastT = e.timeStamp;
      this.render();
    };

    onUp = (e) => {
      const d = this.drag;
      if (!d || e.pointerId !== d.id) return;
      if (d.moved) {
        this.suppressClick = true;
        this.classList.remove('is-dragging');
        this.velocity = Math.max(-3000, Math.min(3000, this.velocity));
      } else {
        this.velocity = 0;
      }
      this.drag = null;
    };

    onFocus = (e) => {
      // Keyboard focus only, and not the focus the lightbox hands back on close:
      // either would leave the strip frozen after a mouse click.
      if (this.lightboxOpen || !e.target.matches(':focus-visible')) return;
      this.focused = true;
      this.viewport.scrollLeft = 0;   // the browser may scroll the clipped box itself
      const btn = e.target.closest('button');
      if (!btn) return;
      const box = this.viewport.getBoundingClientRect();
      const r = btn.getBoundingClientRect();
      if (r.left < box.left + 24) this.x -= box.left + 24 - r.left;
      else if (r.right > box.right - 24) this.x += r.right - (box.right - 24);
      this.render();
    };

    tick = (now) => {
      const dt = Math.min((now - this.last) / 1000, 0.05);
      this.last = now;
      if (!this.drag || !this.drag.moved) {
        if (Math.abs(this.velocity) > 5) {
          this.x += this.velocity * dt;
          this.velocity *= Math.pow(0.04, dt);
        } else {
          this.velocity = 0;
          if (!this.hovered && !this.focused && !this.lightboxOpen) this.x += this.speed * dt;
        }
        this.render();
      }
      this.frame = requestAnimationFrame(this.tick);
    };

    render() {
      const w = this.setWidth;
      if (!w) return;
      this.x = ((this.x % w) + w) % w;
      this.track.style.transform = `translate3d(${-this.x}px, 0, 0)`;
    }
  }

  if (!customElements.get('play-photo-strip')) {
    customElements.define('play-photo-strip', PlayPhotoStrip);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__productTabsSectionBound) return;
    window.__productTabsSectionBound = true;

    function renderVideo(scope) {
      const root = scope || document;
      root.querySelectorAll('.video-open-popup:not([data-video-bound])').forEach((videoOpenPopup) => {
        videoOpenPopup.dataset.videoBound = 'true';
        videoOpenPopup.addEventListener('click', function (e) {
          e.preventDefault();
          const videoId = videoOpenPopup.dataset.videoId;
          const videoWrapper = document.querySelector('.video-modal__content-block');
          if (!videoWrapper || !videoId) return;
          videoWrapper.innerHTML = `<iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
        });
      });
    }

    function ensureVideoModal() {
      if (document.getElementById('PopupModal-product-tabs-video')) return;
      document.body.insertAdjacentHTML(
        'beforeend',
        `<side-drawer class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden" id="PopupModal-product-tabs-video" data-moved="true">
          <div class="drawer__overlay fixed inset-0 cursor-pointer"></div>
          <div class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup">
            <div class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar">
              <div class="video-modal__content-block">Video</div>
              <button onclick="this.closest('side-drawer').close()" class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute" type="button" aria-label="Close dialog" style="--top: 0.3rem; --right: 0.3rem">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg>
              </button>
            </div>
          </div>
        </side-drawer>`
      );
    }

    function openAccordionTab(tabContent) {
      const section = tabContent.closest('.section-product-tabs');
      if (!section) return;
      section.querySelectorAll('.style-accordion .toggle-title.is-open').forEach((el) => el.classList.remove('is-open'));
      tabContent.querySelector('.toggle-title')?.classList.add('is-open');
    }

    function closeAccordionTab(tabContent) {
      tabContent.querySelector('.toggle-title')?.classList.remove('is-open');
    }

    document.addEventListener('click', function (e) {
      const section = e.target.closest('.section-product-tabs');
      if (!section) return;

      const tabTitle = e.target.closest('.tab-title');
      if (tabTitle && section.contains(tabTitle)) {
        e.preventDefault();
        const tabList = section.querySelector('.tabs-list');
        if (!tabList) return;
        const tabTitles = [...tabList.querySelectorAll('.tab-title')];
        const tabContents = [...section.querySelectorAll('.product-tabs-tab .tabs-content > .tab-content')];
        const index = tabTitles.indexOf(tabTitle);
        if (index === -1 || tabTitle.classList.contains('is-active')) return;
        tabTitles.forEach((t) => t.classList.remove('is-active'));
        tabContents.forEach((c) => c.classList.remove('is-active'));
        tabTitle.classList.add('is-active');
        setTimeout(() => {
          const content = tabContents[index];
          if (!content) return;
          content.classList.add('is-animating', 'is-active');
          content.addEventListener(
            'transitionend',
            function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            },
            { once: true }
          );
        }, 10);
        return;
      }

      const toggleLink = e.target.closest('.toggle-link');
      if (!toggleLink || !section.contains(toggleLink)) return;
      e.preventDefault();

      const toggleTitle = toggleLink.closest('.toggle-title');
      if (!toggleTitle) return;

      const tabTitleText = document.querySelector('.tab-title-text');
      if (tabTitleText) tabTitleText.textContent = toggleLink.textContent;

      const viewContentType = toggleTitle.dataset.viewContent;
      const content = toggleTitle.nextElementSibling;
      if (!content) return;

      if (Shopify?.designMode && section.querySelector('.style-accordion')) return;

      switch (viewContentType) {
        case 'sidebar': {
          const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
          if (drawerContent) {
            drawerContent.innerHTML = '';
            drawerContent.appendChild(content.cloneNode(true));
            renderVideo(drawerContent);
          }
          break;
        }
        case 'popup': {
          const popupContent = document.querySelector('.popup-content-wrapper');
          if (popupContent) {
            popupContent.innerHTML = '';
            popupContent.appendChild(content.cloneNode(true));
            renderVideo(popupContent);
          }
          break;
        }
        default:
          toggleTitle.classList.toggle('is-open');
      }
    });

    if (Shopify?.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        openAccordionTab(tabContent);
      });

      document.addEventListener('shopify:block:deselect', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        closeAccordionTab(tabContent);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      ensureVideoModal();
      renderVideo();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
